export const RealtimeMessageType = {
  // NOTEBOOK
  // Keep in sync with benchling/notebook/realtime/constants.py
  ENTRY_UPDATE: 'entry_update',
  LOCK_UPDATE: 'lock_update',
  PUBLISHING_UPDATE: 'publishing_update',
  REVIEW_UPDATE: 'review_update',
  WORKSHEET_UPDATE: 'worksheet_update',
  WORKSHEET_STEP_REOPENED: 'worksheet_step_reopened',
  WORKSHEET_DOCUMENTS_UPDATED: 'worksheet_documents_updated',
  TABLE_API_PENDING_ROWS_UPDATE: 'table_api_pending_rows_update',
  ANALYSIS_STARTED: 'analysis_started',
  // LLM
  LLM_RESPONSE_CHUNK: 'llm_response_chunk',
  LLM_RESPONSE_COMPLETE: 'llm_response_complete',
  TOOL_PROGRESS: 'llm_tool_progress',
  LLM_CHAT_UPDATE: 'llm_chat_update',
  CHAT_MARKED_READ: 'chat_marked_read',
  CHAT_NAME_UPDATED: 'chat_name_updated',
  CHAT_SESSION_CREATED: 'chat_session_created',
  // Keep in sync with AGENT_FOUNDRY_UPDATE_MESSAGE_TYPE in benchling/llm/agent_foundries/realtime/agent_foundry_realtime.py
  AGENT_FOUNDRY_UPDATE: 'agent_foundry_update',
  // FILES
  // Keep in sync with FILE_UPDATE_MESSAGE_TYPE in benchling/files/realtime/file_realtime.py
  FILE_UPDATE: 'file_update',
  // OMNIBOX
  OMNIBOX_PARTIAL: 'omnibox_partial',
  OMNIBOX_COMPLETE: 'omnibox_complete',
  OMNIBOX_HELP_DOCS_COMPLETE: 'omnibox_help_docs_complete',
  // Add new realtime message types here and link to the corresponding Python constants
} as const;

export type RealtimeMessageType = (typeof RealtimeMessageType)[keyof typeof RealtimeMessageType];
